import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { MDBContainer } from "mdbreact";
import Home from "./pages/Home/Home";
import Invoice from "./pages/Invoice/Invoice";
import InvoiceDetail from "./pages/InvoiceDetail/InvoiceDetail";
import Summary from "./pages/Summary/Summary";
import Paid from "./pages/Paid/Paid";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NoRoute from "./pages/404/404";
import Outstanding from "./pages/Outstanding/outstanding";

function App() {
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const user = sessionStorage.getItem("user");
    const signature = sessionStorage.getItem("signature");

    setToken(token);
    setUser(user);
    setSignature(signature);
  }, []);

  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [signature, setSignature] = useState(null);

  const isLoggedIn = (token && user) || (user && signature);

  return (
    <Router>
      <Header />

      <main>
        <MDBContainer>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>

            <Route exact path="/invoice">
              {isLoggedIn ? <Invoice /> : <NoRoute />}
            </Route>

            <Route path="/invoice/:id">
              {isLoggedIn ? <InvoiceDetail /> : <NoRoute />}
            </Route>

            <Route path="/summary">
              {isLoggedIn ? <Summary /> : <NoRoute />}
            </Route>

            <Route path="/paid">{isLoggedIn ? <Paid /> : <NoRoute />}</Route>
            <Route path="/outstanding/detail/:uniqId">
              <Outstanding />
            </Route>
            <Route>
              <NoRoute />
            </Route>
          </Switch>
        </MDBContainer>
      </main>

      <Footer />
    </Router>
  );
}

export default App;
